import {Injectable} from '@angular/core';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {DialogWidth, ThemePalette} from '@q9elements/ui-kit/common';
import {CopyMapDialogComponent} from '@q9elements/ui-kit/maps';
import {IMap, MapService} from './map.service';
import {AuthService} from '../auth/auth.service';
import {DiagramJsonHandlerService} from '../../diagram-data/diagram-json-handler.service';
import {PopupManagerService} from '../services/popup-manager.service';

export interface CopyDisabledReason {
  isProTrial: boolean;
  permissions: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MapCopyService {
  public disabledCopy$: Observable<CopyDisabledReason | null> = this.mapService.map$.pipe(
    map((mapMeta: IMap) => {
      if (!mapMeta) {
        return {
          isProTrial: true,
          permissions: true
        };
      }

      const canCopy = this.authSvc.getCanCopyMap();
      const isProTrial = this.diagramJsonSvc.isProTrial();

      if ((!canCopy && !mapMeta?.copyEnabled) || isProTrial) {
        return {
          isProTrial: isProTrial,
          permissions: canCopy || mapMeta?.copyEnabled
        };
      }

      return null;
    })
  );

  constructor(
    public authSvc: AuthService,
    private mapService: MapService,
    private diagramJsonSvc: DiagramJsonHandlerService,
    private popupService: PopupManagerService
  ) {}

  public copyMap(): void {
    const map = this.mapService.mapSubject.getValue();
    const {mapName} = this.diagramJsonSvc.namings;
    const updatedMap = {...map, name: mapName};

    this.popupService.open(CopyMapDialogComponent, {
      width: DialogWidth.MD,
      panelClass: ['q9-dialog'],
      data: {
        color: ThemePalette.PRIMARY,
        map: updatedMap
      }
    });
  }
}
